export default __webpack_public_path__ + "bac8362e7a6ea60b6983ecf09a411a5e.woff";